import ms from "ms";
import { makeDoubleArgHook } from "../../utils/makeDoubleArgHook";
import getTaskComments from "../requests/getTaskComments";
import { taskCommentsUrl } from "../requests/urls";
export const taskCommentsKeyMaker = (taskId, queryParams) => {
    if (queryParams === null) {
        return [taskCommentsUrl(taskId)];
    }
    return [taskCommentsUrl(taskId), JSON.stringify(queryParams)];
};
const useGetTaskComments = makeDoubleArgHook(async (taskId, queryParams, auth) => getTaskComments(taskId, auth, queryParams), taskCommentsKeyMaker, { staleTime: ms("30seconds") });
export default useGetTaskComments;
//# sourceMappingURL=useGetTaskComments.js.map